import { StyleSheet } from "aphrodite";
import theme from "../common/theme/mellon";

export default StyleSheet.create({
    container: {
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
    },
    skipLink: {
        position: "absolute",
        left: "-9999px",
        top: "auto",
        width: "1px",
        height: "1px",
        overflow: "hidden",
        zIndex: 10000,
        padding: "12px 16px",
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        textDecoration: "none",
        fontWeight: "bold",
        ":focus": {
            left: "16px",
            top: "16px",
            width: "auto",
            height: "auto",
            overflow: "visible",
            outline: `3px solid ${theme.palette.secondary.main}`,
            outlineOffset: "2px",
        },
    },
    stickyTop: {
        position: "sticky",
        top: 0,
        width: "100%",
        zIndex: 1000,
    },
    stickyBottom: {
        position: "sticky",
        bottom: 0,
        width: "100%",
        zIndex: 1000,
    },
    children: {
        flex: 1,
        overflowY: "auto",
    },
    contentWrapper: {
        flex: 1,
        marginBottom: "40px",
        '@media (max-width: 799px)': {
            marginBottom: "30px",
        }
    },
});
